module.exports = __webpack_public_path__ + "static/media/vf_wjacket_core.dfdbef8c.svg";